import { FIND_ONBOARDING_PAGE } from 'constants/pages';
import IndividualGradient from 'svg/IndividualGradient';
import { ButtonLink, ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

/** Shown when a player flips to "For you" before completing the Find questionnaire. */
export default function ForYouPromptModal({ isOpen, onClose }: Props) {
  return (
    <Modal isOpen={isOpen} handleClose={onClose} classNameMaxWidth="max-w-[30rem]">
      <div className="flex flex-col items-center px-ds-2xl pb-ds-2xl pt-ds-3xl text-center">
        <IndividualGradient className="h-16 w-16" />
        <h2 className="typography-product-heading-desktop mt-ds-lg text-pretty text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          Make this feed yours
        </h2>
        <p className="typography-product-body mt-ds-md text-pretty text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          Set your level, location and availability to see the best games, players and programming
          near you.
        </p>
        <ButtonLink
          href={FIND_ONBOARDING_PAGE}
          variant="primary"
          size="lg"
          isInline
          className="mt-ds-2xl"
        >
          Set my preferences
        </ButtonLink>
        <ButtonText
          onClick={onClose}
          className="mt-ds-md text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary"
        >
          Not now
        </ButtonText>
      </div>
    </Modal>
  );
}
